document.querySelectorAll('[data-swyft-catalog-product]').forEach(async root => {
  try {
    const response = await fetch(root.dataset.sourceUrl);
    if (!response.ok) return;
    const part = (await response.json())[root.dataset.sku];
    const urls = JSON.parse(root.querySelector('[data-source-parts]').textContent);
    if (part === undefined || !urls[part]) return;
    const partResponse = await fetch(urls[part]);
    if (!partResponse.ok) return;
    const product = (await partResponse.json())[root.dataset.sku];
    if (!product) return;
    const main = root.querySelector('.gp-bed-main-image');
    const gallery = root.querySelector('[data-source-gallery]');
    for (const image of product.images) {
      const button = document.createElement('button');
      button.type = 'button';
      button.setAttribute('aria-label', image.alt);
      const thumbnail = document.createElement('img');
      thumbnail.src = image.src + (image.src.includes('?') ? '&' : '?') + 'width=150';
      thumbnail.alt = image.alt;
      thumbnail.width = 85;
      thumbnail.height = 70;
      thumbnail.loading = 'lazy';
      button.append(thumbnail);
      button.addEventListener('click', () => { main.removeAttribute('srcset'); main.src = image.src; main.alt = image.alt; });
      gallery.append(button);
    }
    const parsed = new DOMParser().parseFromString(product.description, 'text/html');
    parsed.querySelectorAll('script,iframe,style,form,input,button').forEach(el => el.remove());
    parsed.querySelectorAll('*').forEach(el => { for (const attr of [...el.attributes]) if (attr.name.startsWith('on')) el.removeAttribute(attr.name); });
    root.querySelector('.gp-bed-description').replaceChildren(...parsed.body.childNodes);
    const message = root.querySelector('[data-source-stock]');
    const button = root.querySelector('button[name="add"]');
    if (product.status === 'out') { message.textContent = 'Out of stock'; button.textContent = 'Out of stock'; button.disabled = true; }
    if (product.status === 'preorder' && product.date) {
      const date = new Date(product.date+'T12:00:00Z').toLocaleDateString('en-GB',{day:'numeric',month:'long',year:'numeric',timeZone:'UTC'});
      message.textContent = 'Pre-order — delivery from ' + date;
      button.textContent = 'Pre-order';
      const property = document.createElement('input');
      property.type = 'hidden'; property.name = 'properties[Pre-order delivery from]'; property.value = date;
      button.form.append(property);
    }
  } catch (error) { console.warn('Product gallery could not be loaded', error); }
});
